import { theme } from 'antd';
import { DevicesIcon } from 'assets/images/svg';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectDevicesByGroupID } from 'reduxStore/assetGroups/selectors';
import { Loader } from 'zComponents/atoms';
import DeviceDrawer from 'zComponents/molecules/DeviceDrawer';
import { Empty, Flex, Space, Tag } from 'zui/Antd';

const DevicesPanelContent = ({ groupID }) => {
	const {
		token: { fontWeightStrong, paddingSM, paddingXXS }
	} = theme.useToken();

	// ✅ Select devices from redux
	const devices = useSelector((state) => selectDevicesByGroupID(state, groupID));
	const { loadingAddGroupAsset, loadingDeleteGroupAsset } = useSelector((state) => state.AssetGroups);

	const [selectedDeviceID, setSelectedDeviceID] = useState(null);
	const [openDeviceDrawer, setOpenDeviceDrawer] = useState(false);

	if (loadingAddGroupAsset || loadingDeleteGroupAsset) {
		return (
			<>
				<Flex justify='center' align='start' style={{ width: '100%' }}>
					<Loader />
				</Flex>
			</>
		);
	}

	if (devices.length === 0) {
		return (
			<>
				<Flex justify='center' align='start' style={{ width: '100%' }}>
					<Empty description='No devices' image={Empty.PRESENTED_IMAGE_SIMPLE} />
				</Flex>
			</>
		);
	}

	return (
		<>
			<Space wrap size={paddingSM}>
				{devices.map((device) => (
					<Tag
						key={device.deviceID}
						color='gold'
						style={{
							fontWeight: fontWeightStrong,
							borderColor: 'currentColor',
							cursor: 'pointer',
							marginInlineEnd: 0
						}}
						onClick={() => {
							setSelectedDeviceID(device.deviceID);
							setOpenDeviceDrawer(true);
						}}
					>
						<Flex align='center' gap={paddingXXS}>
							<DevicesIcon color='currentColor' />
							{device.name}
						</Flex>
					</Tag>
				))}
			</Space>
			<DeviceDrawer visible={openDeviceDrawer} setVisible={setOpenDeviceDrawer} deviceID={selectedDeviceID} />
		</>
	);
};

export default DevicesPanelContent;
